const posterImages = {
  "desktop": [
    "/posters/desktop/desktop_1.png",
    "/posters/desktop/desktop_2.png",
    "/posters/desktop/desktop_3.png",
    "/posters/desktop/desktop_4.png",
    "/posters/desktop/desktop_5.png"
  ],
  "mobile": [
    "/posters/mobile/mobile_1.png",
    "/posters/mobile/mobile_2.png",
    "/posters/mobile/mobile_3.png",
    "/posters/mobile/mobile_4.png",
    "/posters/mobile/mobile_5.png"
  ]
};

export default posterImages;
